// © Microsoft Corporation. All rights reserved.

import { FluentSelect, FluentOption } from "@fluentui/web-components";
import { ViewTemplate, html, when, ref, repeat } from "@microsoft/fast-element";
import { telemetry } from "@fast/components";

import { MarketSelector } from "./MarketSelector";
import { MarketSelectorOptionProps } from "./Interfaces";
import { IconSvgs } from "@msnews/wc-shared";

// Tree-shaking
FluentSelect;
FluentOption;

// Template for market selector option
const MarketSelectorOptionTemplate: ViewTemplate<MarketSelectorOptionProps> = html<MarketSelectorOptionProps>`
<fluent-option
    id=${x => x.id}
    value=${x => x.value}
    dir=${x => x.direction}
    ${telemetry(x => x.marketSelectorOptionMetaTag)}
>
    ${x => x.displayString}
</fluent-option>
`;

// Template for market selector with label (if available)
export const MarketSelectorTemplate: ViewTemplate<MarketSelector> = html<MarketSelector>`
${when(x => x.label, html<MarketSelector>`<span>${x => x.label}</span>`)}
<fluent-select
    id=${x => x.id}
    class="select"
    part="select"
    position=${x => x.selectPosition}
    ?disabled=${x => x.disabled}
    :selectedIndex="${x => x.selectedIndex}"
    @change=${(x, c) => x.onChange(c.event as CustomEvent)}
    ${ref("select")}
    ${telemetry(x => x.marketSelectorMetaTag)}
>
    ${repeat(x => x.marketList, MarketSelectorOptionTemplate)}
    <div class="selector-icon" slot="indicator">
        <slot name="selector-icon">
            ${IconSvgs.dropdownIcon}
        </slot>
    </div>
</fluent-select>
`;
